<template>
	<div>
		<Layout :back="'/'" class="bg-primary ">
			<template slot="header">
				<h1>Bases y condiciones</h1>
			</template>

			<div class="main-container p-4">
				<p>
					BASES Y CONDICIONES DE LA PROMOCIÓN “LG te lleva a Madrid a ver a Suarez”<br /><br />

					Participantes y Mecánica de participación para vendedores autorizados de Estawol S.A.<br /><br />

					1- Estawol S.A. es la empresa organizadora de la presente campaña cuyas bases y condiciones se detallan a continuación:<br /><br />

					2- La presente promoción tendrá vigencia desde el 1º de Noviembre de 2021 hasta el 31 de Marzo de 2022.<br /><br />

					3- Podrán participar de esta promoción todos los clientes de Estawol que compren productos LG a efectos de comercializar los productos a consumidores finales (B2C). <br /><br />

					4- Quienes deseen participar deberán registrar sus ventas de manera gratuita en la página web https://vendedores.ltienda.com.uy/<br /><br />

					5- Los ganadores se definirán según la venta que tengan asociada a los puntajes correspondientes (ver en https://vendedores.ltienda.com.uy/). Los primeros 15 vendedores con mayor puntaje participarán del sorteo para el
					viaje.<br /><br />

					6- Se contemplarán las ventas (sell out) que se den desde el 01/11/2021 al 31/03/2022 registradas en la página web mediante factura adjunta. Aplicarán todos los productos de la marca que distribuye Estawol S.A., sin
					importar si el vendedor ya cuenta con inventario de mercadería. <br /><br />

					7- No contarán ventas duplicadas y quedarán fuera de competencia aquellos que incumplan esta norma. <br /><br />
					<br /><br />

					<strong>Premios:</strong><br /><br />

					8- El premio consiste en un pasaje ida y vuelta en clase turista a Madrid, alojamiento durante el viaje y entrada al partido del Atlético de Madrid vs. Real Madrid. <br /><br />

					<br /><br />
					<strong>Otras disposiciones.</strong><br /><br />

					9- El simple hecho de participar en esta promoción implica el conocimiento y aceptación de las presentes Bases y Condiciones Generales.<br /><br />

					10- Los ganadores serán notificados por Estawol S.A. a la dirección de correo electrónico y/o al teléfono asociado al momento del registro. A partir de recibida la notificación, el ganador tendrá un plazo de 10 días
					corridos para aceptar o rechazar el premio.<br /><br />

					11- Si dentro de dicho plazo el ganador no se contactare de forma fehaciente con Estawol S.A. a efectos de aceptar o rechazar el premio, perderá automáticamente su derecho al mismo. En este caso, así como en el caso de
					que el ganador no pueda o no quiera hacerse acreedor del premio de acuerdo con las Bases y Condiciones, se acudirá a realizar un siguiente sorteo. <br /><br />

					12-En caso de comunicarse por el ganador la aceptación del premio, el mismo tendrá 15 días corridos para gestionarlo desde recibida la notificación. El retiro del premio se realizará en Dr. Héctor Miranda 2361 of. 806 -
					Sinergia Golf. <br /><br />

					13- Por el solo hecho de participar en la promoción, el usuario y/o interesado autoriza de forma expresa a Estawol S.A. en caso de ser necesario, difundir y/o divulgar sus imágenes y/o voces con fines publicitarios y/o
					comerciales, por el plazo de 6 (seis) meses posteriores a la finalización de la acción, en su sitio web y/o redes sociales y/o cualquier otro medio que Estawol S.A. disponga.<br /><br />

					14- Estawol S.A. podrá modificar las Bases y Condiciones de la promoción “LG te lleva a Madrid a ver a Suarez” en forma total y/o parcial, así como cancelar o suspender la promoción cuando se presenten situaciones no
					imputables a Estawol S.A. o situaciones no previstas, sin derecho de indemnización alguna a los usuarios y participantes. Cualquier modificación a las presentes bases será difundida previamente. <br /><br />

					15- El premio no será canjeable, ni transferible a terceras personas y tampoco podrá ser canjeado por efectivo. Estawol S.A. no será responsable por ningún daño o perjuicio, de cualquier tipo, que pudiere sufrir el
					participante con motivo de su participación en la promoción en el uso de los productos o servicios adquiridos en virtud de la utilización del premio. Estawol S.A. no garantiza ni se responsabiliza por agentes externos
					tales como trámites con la aerólinea, cancelación del partido por parte de las autoridades pertinentes, etc. <br /><br />

					16-El ganador deberá cumplir con los requisitos impuestos por las autoridades sanitarias del país de destino a efectos de cumplir con las políticas asociadas al Covid-19.<br /><br />

					17- Para dirimir cualquier discrepancia derivada de la presente promoción y de las presentes Bases y Condiciones, se someterán a la jurisdicción de los tribunales de la ciudad de Montevideo.<br /><br />

					18- El simple hecho de participar en esta promoción implica el conocimiento y aceptación de las Bases y Condiciones, las cuales pueden consultarse en el sitio web https://www.ltienda.com.uy/lgamadrid<br /><br />

					19- Asimismo, el hecho de participar en esta promoción implica que el participante acepta recibir notificaciones, comunicaciones y promociones por parte de Estawol S.A. a través de los diferentes medios de comunicación
					que utiliza la empresa, como ser y sin que implique limitación: correos electrónicos, mensajes de texto, etc.
				</p>
			</div>
		</Layout>
	</div>
</template>
<script>
import Layout from '@/components/layout/Layout'

export default {
	name: 'Conditions',
	components: {
		Layout,
	},
}
</script>

<style scoped>
h1 {
	font-size: 22pt;
	color: #fff;
}
.main-container {
	background-color: #fff;
	border-radius: 24px 0px 0px 0px;
}
</style>
